import { Box, css, styled } from '@mui/material';

export const FormIndent = styled(Box)(
  ({ theme }) => css`
    margin-left: ${theme.spacing(2)};
  `,
);
